import React, { useContext, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { authContext } from '../../configurations/auth/authContext';
import Input from '../controls/Input';
import { Authenticate } from '../../configurations/crud/authenticationCrud';
import { setLoginInfo } from '../../configurations/auth/setLoginInfo';
import { useFormik } from 'formik';
import * as yup from 'yup'
import { Link, redirect, useNavigate } from 'react-router-dom';
import LodingButton from '../controls/LodingButton';
import { useToast } from '../controls/Toast/ToastService';
import { MdErrorOutline } from 'react-icons/md';
import { FaUserDoctor } from "react-icons/fa6";
import { FaStethoscope, FaShieldHeart, FaBoltLightning, FaArrowLeftLong } from "react-icons/fa6";
import { Capacitor } from '@capacitor/core';
import Footer from '../base/Footer';
import useGlobalLoader from '../../configurations/useGlobalLoader';
import useRegisterPush from '../../configurations/push/pushNotification';

const schema = yup.object().shape({
    userName: yup.string().required("User name is required"),
    password: yup.string().required("Password is required.")
})

export default function Login() {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [isLogin, setIsLogin] = useContext(authContext);
    const [loding, setLoding] = useState(false)
    const navigate = useNavigate()
    const { handleRegisterDoctor } = useRegisterPush()

    const { values, handleChange, handleBlur, handleSubmit, errors, touched, isValid } = useFormik({
        initialValues: { userName: "", password: "" },
        validationSchema: schema,
        onSubmit(values) { getlogin(values) }
    })

    const getlogin = async (val) => {
        setLoding(true)
        start()
        try {
            let res = await Authenticate(val.userName, val.password)
            let data = res.data
            if (data && data.result.succeeded) {
                setLoginInfo(JSON.stringify(data))
                setIsLogin(true)
                if (Capacitor.isNativePlatform()) {
                    await handleRegisterDoctor(data.id);
                }
                redirect("/home")
                setLoding(false)
                end()
            } else {
                toast.open(data.result.message, <MdErrorOutline />, "danger")
                setLoding(false)
                end()
            }

        } catch (error) {
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            setLoding(false)
            end()
        }
    }

    if (isLogin) return <h1>Loged In</h1>

    return (
        <div className="min-h-screen w-full lg:grid lg:grid-cols-2 bg-slate-100">
            {/* ---- Brand panel (desktop) ---- */}
            <div className="relative hidden lg:flex flex-col justify-between overflow-hidden bg-gradient-to-br from-brand-500 via-brand-500 to-blue-800 p-12 text-white">
                <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-white/10 blur-2xl" />
                <div className="absolute bottom-0 -left-20 h-80 w-80 rounded-full bg-brand-300/20 blur-2xl" />
                <img src="/assets/images/logo-white.svg" alt="Doctora" className="relative h-9 w-auto" />
                <div className="relative">
                    <h1 className="font-display text-4xl font-extrabold leading-tight">Run your OPD,<br />the modern way.</h1>
                    <p className="mt-4 max-w-md text-white/80">Queue management, live patient flow and fast notes — built for busy clinics.</p>
                    <div className="mt-8 space-y-3 text-sm">
                        <div className="flex items-center gap-3"><span className="grid place-items-center h-9 w-9 rounded-xl bg-white/15"><FaBoltLightning /></span> Real-time live OPD queue</div>
                        <div className="flex items-center gap-3"><span className="grid place-items-center h-9 w-9 rounded-xl bg-white/15"><FaStethoscope /></span> Doctor & reception dashboards</div>
                        <div className="flex items-center gap-3"><span className="grid place-items-center h-9 w-9 rounded-xl bg-white/15"><FaShieldHeart /></span> Secure patient records</div>
                    </div>
                </div>
                <p className="relative text-xs text-white/60">© {new Date().getFullYear()} Doctora OPD</p>
            </div>

            {/* ---- Form ---- */}
            <div className="relative flex flex-col justify-start lg:justify-center min-h-screen lg:py-8 px-0 lg:px-10">
                {/* mobile brand hero */}
                <div className="lg:hidden relative overflow-hidden bg-gradient-to-br from-brand-500 via-brand-500 to-blue-800 px-6 pt-10 pb-16 rounded-b-[2rem] text-white">
                    <div className="absolute -top-16 -right-12 h-52 w-52 rounded-full bg-white/10 blur-2xl" />
                    <Link to="/" className="absolute left-4 top-4 inline-flex items-center gap-1.5 text-sm font-medium text-white/90 bg-white/15 hover:bg-white/25 rounded-xl px-3 py-1.5 transition">
                        <FaArrowLeftLong /> Back
                    </Link>
                    <img alt="Doctora OPD" src="/assets/images/logo-white.svg" className="relative mt-6 h-9 w-auto animate-fade-up" />
                    <h1 className="relative font-display text-2xl font-extrabold mt-4 animate-fade-up">Welcome back</h1>
                    <p className="relative text-white/85 text-sm mt-1 animate-fade-up">Sign in to manage your OPD.</p>
                </div>

                <div className="mx-auto w-full max-w-sm px-6 sm:px-0 -mt-10 lg:mt-0 animate-fade-up">
                    <div className="card-surface p-6 sm:p-8 lg:mt-0">
                        <div className="hidden lg:block">
                            <h2 className="font-display text-2xl font-bold text-gray-900">Welcome back</h2>
                            <p className="mt-1 text-sm text-gray-500">Sign in to continue to your dashboard.</p>
                        </div>

                        <form onSubmit={handleSubmit} autoComplete='off' className="mt-6 space-y-5">
                            <div>
                                <label htmlFor="userName" className="block text-sm font-medium text-gray-700 mb-1.5">Mobile no.</label>
                                <Input tabIndex={1} placeholder="Enter mobile no." id="userName"
                                    Icon={<FaUserDoctor />}
                                    value={values.userName} onChange={handleChange} onBlur={handleBlur}
                                    isError={errors.userName && touched.userName} />
                                {errors.userName && touched.userName && <p className='mt-1 text-red-600 text-xs'>{errors.userName}</p>}
                            </div>

                            <div>
                                <div className="flex items-center justify-between mb-1.5">
                                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                                    <div className="text-sm flex gap-1.5">
                                        <Link tabIndex={5} to="/create-doctor" className="hyper-link">Register</Link>
                                        <span className="text-gray-300">|</span>
                                        <Link tabIndex={6} to="/forgot" className="hyper-link">Forgot?</Link>
                                    </div>
                                </div>
                                <Input tabIndex={2} type="password" id="password" placeholder="Enter password"
                                    Icon={<FontAwesomeIcon icon={faLock} />}
                                    value={values.password} onChange={handleChange} onBlur={handleBlur}
                                    isError={errors.password && touched.password} />
                                {errors.password && touched.password && <p className='mt-1 text-red-600 text-xs'>{errors.password}</p>}
                            </div>

                            <div className='flex gap-2 pt-1'>
                                {!loding ?
                                    <>
                                        <button tabIndex={3} className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid} type='submit'>Sign in</button>
                                        <button tabIndex={4} onClick={() => navigate("/")} className="btn-default" type='button'>Back</button>
                                    </>
                                    :
                                    <LodingButton text={"Signing In.."} />
                                }
                            </div>
                        </form>
                    </div>

                    <p className="mt-6 text-center text-sm text-gray-500">
                        <Footer isForLogin={true} />
                    </p>
                </div>
            </div>
        </div>
    )
}
